module.exports = __webpack_public_path__ + "img/Reporting Order.9b9a1ef2.png";